import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorReportingService } from '../_service/error-reporting.service';

const SKIP_ENDPOINTS = ['/api/client-errors'];

export const httpErrorReportingInterceptor: HttpInterceptorFn = (req, next) => {
  const errorReporter = inject(ErrorReportingService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        const url = req.url ?? '';
        const shouldSkip = SKIP_ENDPOINTS.some((e) => url.includes(e));

        if (!shouldSkip) {
          errorReporter.report({
            message: `HTTP ${err.status} ${err.statusText || 'Error'}: ${url}`,
            error_type: 'HttpErrorResponse',
            severity: err.status >= 500 ? 'error' : 'warning',
            status_code: err.status,
            endpoint: url,
            extra: { method: req.method },
          });
        }
      }
      return throwError(() => err);
    }),
  );
};
